export const categories = [
  {
    key: "drama",
    name: "电视剧",
    type: "电视剧",
    icon: "ri-tv-2-line",
    description:
      "汇集日韩热门电视剧集，从治愈日常到悬疑犯罪，全程中文字幕，一集接一集停不下来。",
  },
  {
    key: "movie",
    name: "电影",
    type: "电影",
    icon: "ri-film-line",
    description:
      "精选日韩口碑电影，爱情、剧情、惊悚、动画全覆盖，配中文字幕，随时开启一段光影旅程。",
  },
];